(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["em-sibling-swatches"] && !Shopify.designMode) return;
  try {
    // PDP: variant-picker内のColorフィールドセットを非表示
  (function () {
    function hidePdpColorFieldset() {
      var variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return;
      if (!document.querySelector('.em-swatches--pdp')) return;
      variantPicker.querySelectorAll('fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (legend && legend.textContent.trim() === 'Color') {
          fs.style.setProperty('display', 'none', 'important');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        hidePdpColorFieldset();
        var picker = document.querySelector('variant-picker');
        if (picker) new MutationObserver(hidePdpColorFieldset).observe(picker, { childList: true, subtree: true });
      });
    } else {
      hidePdpColorFieldset();
      var picker = document.querySelector('variant-picker');
      if (picker) new MutationObserver(hidePdpColorFieldset).observe(picker, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["em-variant-color-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function initVariantSwatches() {
      document.querySelectorAll('.em-variant-swatches--pdp').forEach(function (el) {
        if (el.dataset.emInit) return;
        el.dataset.emInit = '1';

        var optionName = el.dataset.optionName;

        // Color fieldset を非表示にする（再レンダリング対策でMutationObserverも使用）
        var variantPicker = document.querySelector('variant-picker');
        var colorFieldset = null;

        function hideColorFieldset() {
          if (!variantPicker) return;
          variantPicker.querySelectorAll('fieldset').forEach(function (fs) {
            var legend = fs.querySelector('legend');
            if (legend && legend.textContent.trim() === optionName) {
              colorFieldset = fs;
              fs.style.setProperty('display', 'none', 'important');
            }
          });
        }
        hideColorFieldset();
        if (variantPicker) {
          new MutationObserver(hideColorFieldset).observe(variantPicker, { childList: true, subtree: true });
        }

        // 各スウォッチボタンにクリックイベント
        el.querySelectorAll('.em-variant-swatches__item').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var colorName = btn.dataset.color;

            // 選択状態の更新
            el.querySelectorAll('.em-variant-swatches__item').forEach(function (b) {
              b.classList.remove('em-variant-swatches__item--current');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('em-variant-swatches__item--current');
            btn.setAttribute('aria-pressed', 'true');

            // variant-picker の対応ラジオを選択してvariant変更を発火
            if (colorFieldset) {
              var input = colorFieldset.querySelector('input[value="' + colorName.replace(/"/g, '\\"') + '"]');
              if (input) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
        });
      });
    }

    function start() {
      initVariantSwatches();
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.em-variant-swatches--pdp')) {
              initVariantSwatches();
            } else if (node.querySelector && node.querySelector('.em-variant-swatches--pdp')) {
              initVariantSwatches();
            }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
